/*
Copyright © SITA INC Ireland, SITA INC USA, SITA Switzerland Sarl 2025. Confidential. All rights reserved.
*/
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { provideAnimations } from '@angular/platform-browser/animations';

import { CSP_NONCE } from '@angular/core';
// Read nonce from the root element
const nonce = document.querySelector('app-root')?.getAttribute('ngCspNonce') || '';

  platformBrowserDynamic().bootstrapModule(AppModule, {
    providers:[provideAnimations(),
      { provide: CSP_NONCE, useValue: nonce }
    ],
    ngZoneEventCoalescing: true,
  })
    .catch(err => console.error(err));

